import {Button, Col, Divider, Form, Input, InputNumber, message, Modal, Row, Switch, Table} from 'antd';
import {ColumnsType} from 'antd/es/table';
import React, {useEffect, useState} from 'react';
import PageHeader from "../components/PageHeader";
import {
    useDeleteCommentMutation,
    useEditCommentMutation,
    useFetchBattlesQuery,
    useGetCommentQuery
} from "../redux/api/battle";
import {CheckOutlined, CloseOutlined, ExclamationCircleOutlined} from "@ant-design/icons";

interface DataType {
    key: string;
    id: string;
    battle_name: string;
    moderate: boolean;
    text: string;
    username: string;
    battle_id: string;
    actions: string;
}

interface DeleteProp {
    battle_id: string;
    id: string;
}

const CommentPage = () => {
    const {confirm} = Modal;
    const [form] = Form.useForm();
    const validateMessages = {
        required: "${label} is required!",
    };
    const {data = [], refetch, isLoading} = useFetchBattlesQuery('', {
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })
    const [editComment, {isSuccess: isUpdate}] = useEditCommentMutation()
    const [deleteComment, {isSuccess: isDelete}] = useDeleteCommentMutation()
    const [open, setOpen] = useState(false)
    const [battle_id, setBattleId] = useState('')
    const [comment_id, setCommentId] = useState('')
    const showDeleteConfirm = ({battle_id, id}: DeleteProp) => {
        confirm({
            title: 'Are you sure, You want to delete this comment?',
            icon: <ExclamationCircleOutlined/>,
            okText: 'Yes, delete',
            okType: 'danger',
            cancelText: 'Cancel',
            onOk() {
                deleteComment({battle_id, id})
                refetch()
            },
            onCancel() {
                message.info({
                    content: 'Delete canceled', style: {
                        marginTop: '20px',
                    },
                });

            },
        });
    };

    useEffect(() => {
        if (isUpdate) {
            refetch()
        }
    }, [isUpdate])


    useEffect(() => {
        if (isUpdate) {
            message.success({
                content: 'Successfully update the comment.', style: {
                    marginTop: '20px',
                },
            });
        }
        // console.log(isUpdate)

        if (isDelete && !isUpdate) {
            message.success({
                content: 'Successfully delete the comment.', style: {
                    marginTop: '20px',
                },
            });
        }
        //
        // if (error) {
        //     message.error({
        //         content: {error}, style: {
        //             marginTop: '20px',
        //         },
        //     });
        // }
    }, [data]);


    const handleSwitchChange = (record: DataType, check: boolean) => {
        const vals = {
            comment_battle_id: record.battle_id,
            id: record.id,
            comment_moderate: check
        }
        editComment(vals)
        refetch()
    }


    const columns: ColumnsType<DataType> = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            width: '3%',
            sorter: (a, b) => parseInt(a.id) - parseInt(b.id),
            render: (id, record) => {
                return (<Button type="link" onClick={() => {
                    setOpen(true)
                    setBattleId(record.battle_id)
                    setCommentId(record.id)
                }}>{id}</Button>)
            }
        },
        {
            title: 'Battle Name',
            dataIndex: 'battle_name',
            key: 'battle_name',
            width: '15%'
        },
        {
            title: 'Text',
            dataIndex: 'text',
            key: 'text',
            width: '30%'
        },
        {
            title: 'Author Name',
            dataIndex: 'username',
            key: 'username',
            width: '8%'
        },
        {
            title: 'Public',
            dataIndex: 'moderate',
            key: 'moderate',
            width: '5%',
            render: (e, record) => {
                return (
                    <Switch
                        checkedChildren={<CheckOutlined/>}
                        unCheckedChildren={<CloseOutlined/>}
                        onChange={(checked) => {
                            handleSwitchChange(record, checked)
                        }}
                        defaultChecked={e}
                        checked={e}
                    />
                )
            }
        },
        {
            title: 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            width: '15%',
            render: (id, record) => {
                return (<>
                    <Button type="link" onClick={() => {
                        setOpen(true)
                        setBattleId(record.battle_id)
                        setCommentId(record.id)
                    }}>Edit</Button>
                    <Divider type='vertical'/>
                    <Button
                        danger
                        type="link"
                        onClick={() => {
                            showDeleteConfirm({battle_id: record.battle_id, id: record.id})
                        }}
                    >Delete</Button>
                </>)
            }
        }
    ];
    const commentsData: DataType[] = [];
    if (data) {
        for (const item of data) {
            for (const comment of item.comments) {
                commentsData.unshift({
                    key: comment.id,
                    id: comment.id,
                    battle_name: item.title,
                    moderate: Boolean(parseInt(comment.comment_moderate)),
                    text: comment.comment_text,
                    username: comment.comment_author,
                    battle_id: comment.comment_battle_id,
                    actions: comment.comment_battle_id
                })
            }
        }
    }

    let comment_data = {}

    if (battle_id) {
        const {comments} = data.find(item => item.id === battle_id)
        const comment = comments.find(({id}) => id === comment_id)
        comment_data = {
            comment_author: comment.comment_author,
            comment_text: comment.comment_text,
            comment_rating: comment.comment_rating,
            comment_moderate: Boolean(parseInt(comment.comment_moderate)),
            id: comment.id,
            comment_battle_id: comment.comment_battle_id
        }


    }

    useEffect(() => {
        form.setFieldsValue(comment_data)
    }, [comment_data])

    return (
        <>
            <PageHeader text={<h1 className="wp-heading-inline" style={{fontSize: 18}}>Comments</h1>}/>
            <Table columns={columns} dataSource={commentsData} bordered={true} loading={isLoading}/>
            <Modal
                open={open}
                title="Update comment"
                okText="Update"
                cancelText="Cancel"
                onCancel={() => {
                    setOpen(false)
                }}
                onOk={() => {
                    form
                        .validateFields()
                        .then(values => {
                            form.resetFields();
                            editComment(values)
                            setOpen(false)
                        })
                        .catch(info => {
                            console.log('Validate Failed:', info);
                        });
                }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    name="editComment"
                    validateMessages={validateMessages}
                >
                    <Form.Item hidden={true} name="id">
                        <Input/>
                    </Form.Item>
                    <Form.Item hidden={true} name="comment_battle_id">
                        <Input/>
                    </Form.Item>
                    <Row gutter={10}>
                        <Col span={12}>
                            <Form.Item
                                name="comment_moderate"
                                label="Public"
                                initialValue={true}
                                valuePropName="checked"
                            >
                                <Switch
                                    checkedChildren={<CheckOutlined/>}
                                    unCheckedChildren={<CloseOutlined/>}
                                />
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item
                                name="comment_rating"
                                label="Rating"
                                initialValue={0}
                            >
                                <InputNumber min={0} style={{width: '100%'}}/>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Form.Item  name="comment_author" label="Username" rules={[{required: true}]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item label="Text" name="comment_text" rules={[{required: true}]}>
                        <Input.TextArea rows={3}/>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default CommentPage;

